<template>
  <div>
    <el-table v-loading="loading" :data="gridData">
      <el-table-column property="type_str" label="错误类型" width="150" />
      <el-table-column property="wechat_name" label="公众号名称" width="200" />
      <el-table-column property="exception_info" label="错误信息" />
      <el-table-column property="created_at" label="创建时间" min-width="200" />
      <el-table-column align="center" label="操作" min-width="300">
        <template scope="scope">
          <el-tag v-if="scope.row.status === 2" class="activew" type="success" @click="notprocessed(scope.row,1)">{{ scope.row.status_str }}</el-tag>
          <el-tag v-if="scope.row.status === 1" class="activew" type="danger" @click="notprocessed(scope.row,2)">{{ scope.row.status_str }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { geterrorinform, editerrorinform } from '@/api/providerAccountManagement/WeChatAccountFans'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      gridData: [],
      ids: null,
      reportQuery: {
        page: 1,
        page_size: 10
      },
      total: null,
      loading: false
    }
  },
  methods: {
    // 请求异常信息
    async geterrorinfo() {
      this.loading = true
      const data = await geterrorinform({
        account_id: this.ids,
        ...this.reportQuery
      })
      this.loading = false
      this.gridData = data.data.list
      this.total = data.data.total
      console.log('data', data.data)
    },
    // 未处理请求
    async notprocessed(row, status) {
      const data = await editerrorinform({
        id: row.id,
        status: status
      })
      this.geterrorinfo()
      this.$emit('updatalist')
      console.log('data', data)
    },
    open(val) {
      console.log(val)
      this.ids = val
      this.geterrorinfo()
    },
    fetchPageSize(e) {
      this.reportQuery.page_size = e
      this.geterrorinfo()
    },
    fetchCurrentPage(e) {
      this.reportQuery.page = e
      this.geterrorinfo()
    }
  }
}
</script>

<style scoped lang="less">
.activew{
      cursor: pointer;
  }
</style>
